export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    activeClass: {
      type: Object,
      default: function () {
        return {
          field: '',
          label: '',
          input: ''
        }
      }
    },
    inputStyle: {
      type: [Object, String]
    },
    inputClass: {
      type: Array,
      default: () => [
        'w-full',
        'outline-none',
        'rounded',
        'pr-6',
        'pl-4'
      ]
    }
  },

  data () {
    return {
      inputValue: this.value,
      active: false
    }
  },

  computed: {
    listeners () {
      const listeners = { ...this.$listeners }

      delete listeners.input
      delete listeners.blur
      delete listeners.focus

      return listeners
    },

    placeholderMessage () {
      return !this.innerLabel && this.placeholder ? this.placeholder : ''
    },

    fieldClasses () {
      return ['relative', this.fieldClass, {
        [this.activeClass.label]: this.active,
        [this.disabledClass.field]: this.disabled
      }]
    }
  },

  methods: {
    onInput (event) {
      this.inputValue = event.target ? event.target.value : event

      this.$emit('input', this.inputValue)
    },

    onBlur (event) {
      if (!this.inputValue) {
        this.active = false
      }

      this.$emit('blur', event)
    },

    onFocus (event) {
      if (!this.inputValue) {
        this.active = true
      }

      this.$emit('focus', event)
    }
  }
}
